import { getLogger } from '@omnia/ui/src/lib/services/logger/logger.service'
import { cancelOrder, orderDomainStore } from '@vista-digital/occ-domain'
import { ticketingWorkflow } from '@/content/services/workflows/ticketing/ticketing-workflow'
import { navigationService } from './navigation.service'
import { giftStoreWorkflow } from './workflows/giftStore/gift-store-workflow'
import { limitlessWorkflow } from './workflows/limitless/limitless-workflow'

class MemberService {
    private logger = getLogger('MemberService')
    public onSignedOut() {
        this.logger.value.debug('User signed out, clearing orders, refreshing...')
        this.clearOrder()
        navigationService.goToPage('Home')
    }

    private clearOrder() {
        orderDomainStore.hydrate()
        cancelOrder()
        orderDomainStore.reset()
        // orderDomain.temporaryStore.reset()

        // Clear the workflows
        ticketingWorkflow.end()
        limitlessWorkflow.end()
        giftStoreWorkflow.end()
    }

    // Probably not very reliable
    // memberObs = observable.box(null as Member)

    // getMember = () => this.memberObs.get()
    // setMember(member: Member) {
    //     runInAction(() => {
    //         this.memberObs.set(member)
    //     })

    //     return true
    // }
}

export const memberService = new MemberService()
